import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accountTypePatch } from "../../store/accountType/actions";
export var useAccountTypePatch = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseAccountTypePatch: (_a = state.AccountType.responseAccountTypePatch) === null || _a === void 0 ? void 0 : _a.data,
            errorAccountTypePatch: state.AccountType.errorAccountTypePatch,
            loadingAccountTypePatch: state.AccountType.loadingAccountTypePatch,
        });
    }), responseAccountTypePatch = _a.responseAccountTypePatch, errorAccountTypePatch = _a.errorAccountTypePatch, loadingAccountTypePatch = _a.loadingAccountTypePatch;
    useEffect(function () {
        if (trigger) {
            dispatch(accountTypePatch({
                clientId: body.data.clientId,
                description: body.data.description,
            }, id));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseAccountTypePatch: responseAccountTypePatch,
        errorAccountTypePatch: errorAccountTypePatch,
        loadingAccountTypePatch: loadingAccountTypePatch,
    };
};
